function Truncate(data, length) {
    if (data.length > length) {
        return data.slice(0, length) + '...';
    }
    return data;
}

export default Truncate;
